<template>
  <modal ref="networksFilterModal" >
    <div class="viewership-filter">
      <tabs>
        <tab name="WBD">
          <div class="viewership-filter__networks-container">
            <button class="viewership-filter__network"
                    v-for="network in turnerNetworks"
                    :key="network.id"
                    :class="{'viewership-filter__network--selected': isSelected(network.id)}"
                    @click="selectNetwork(network.id)">
              <img v-if="hasUrl(network)" :src="network.url"/>
              <template v-else>{{ network.name }}</template>
            </button>
          </div>
        </tab>
        <tab name="NON-WBD">
          <div class="viewership-filter__networks-container">
            <button class="viewership-filter__network__non-turner non-turner"
                    v-for="network in nonTurnerNetworks"
                    :key="network.id"
                    :class="{'viewership-filter__network--selected': isSelected(network.id)}"
                    @click="selectNetwork(network.id)">
              <img v-if="hasUrl(network)" :src="network.url"/>
              <template v-else>{{ network.name }}</template>
            </button>
          </div>
        </tab>
      </tabs>
    </div>
    <div class="viewership-filter__actions" slot="actions">
      <v-alert dense text type="warning" style="margin-bottom: 0" v-if="errorNoNetworks">Please select at least one network</v-alert>
      <v-alert dense text type="warning" style="margin-bottom: 0" v-if="errorToManySelected">Please narrow your selection from {{ currentLength }} to {{ maxNumberOfNetworks }} or less</v-alert>
      <action-button @click.native="close" label="cancel" id="cancelNetworkSelection" color="secondary" />
      <action-button @click.native="submitNewSelection" :disabled="disableSubmit" label="update" id="updateNetworkSelection" color="success" />
    </div>
  </modal>
</template>

<script>
  // TODO fix this
  import {SET_SELECTED_NETWORKS} from '@/appLogic/workbench/LAS/store/actions'
  import { isEmpty, cloneDeep, isEqual } from 'lodash'
  import TabsComponents from '@/components/common/tabs'
  import Modal from '@/components/common/modal/Modal.vue'
  import ActionButton from '@/components/common/actionButton'
  const { Tabs, Tab } = TabsComponents

  const MAX_LIMIT_OF_NETWORKS = 100

  export default {
    components: {
      Modal,
      Tabs,
      Tab,
      ActionButton
    },
    props: {
      networks: {
        type: Array,
        required: true
      },
      selectedNetworks: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        copyOfSelectedNetworks: cloneDeep(this.selectedNetworks),
        maxNumberOfNetworks: MAX_LIMIT_OF_NETWORKS
      }
    },
    computed: {
      turnerNetworks () {
        return this.networks.filter(net => net.wbd)
      },
      nonTurnerNetworks () {
        return this.networks.filter(net => net.wbd === false)
      },
      currentLength () {
        return this.copyOfSelectedNetworks.length
      },
      errorNoNetworks () {
        return (this.currentLength === 0)
      },
      errorToManySelected () {
        return (this.currentLength > MAX_LIMIT_OF_NETWORKS)
      },
      disableSubmit () {
        return (isEqual(this.copyOfSelectedNetworks, this.selectedNetworks) ||
          this.errorNoNetworks || this.errorToManySelected)
      }
    },
    methods: {
      hasUrl (network) {
        return !isEmpty(network.url)
      },
      isSelected (id) {
        return this.copyOfSelectedNetworks.indexOf(id) > -1
      },
      selectNetwork (id) {
        this.$emit('select', id)
        const selected = this.copyOfSelectedNetworks.indexOf(id)
        selected > -1 ? this.copyOfSelectedNetworks.splice(selected, 1) : this.copyOfSelectedNetworks.push(id)
      },
      open () {
        // reset the selected networks
        this.copyOfSelectedNetworks = cloneDeep(this.selectedNetworks)
        this.$refs.networksFilterModal.open()
      },
      close () {
        this.$refs.networksFilterModal.close()
        this.$emit('close')
      },
      submitNewSelection () {
        this.$store.dispatch('workbench/' + SET_SELECTED_NETWORKS, this.copyOfSelectedNetworks)
        this.$emit('newSelection', this.copyOfSelectedNetworks)
        this.close()
      }
    }
  }
</script>

<style lang="scss">
  .viewership-filter {
    &__networks-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 20px;
      overflow-x: hidden;
      overflow-y: auto;
    }

    &__network {
      display: flex;
      align-items: center;
      justify-content: center;
      @include naked-btn;
      width: 96px;
      height: 96px;
      border-radius: 50%;
      background: color(grays, light);
      color: white;
      font-weight: bold;
      margin: 10px;

      &__non-turner {
        display: flex;
        align-items: center;
        justify-content: center;
        @include naked-btn;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: color(grays, light);
        color: white;
        font-weight: bold;
        font-size: 10px;
        margin: 10px;
        line-height: 10px;
      }

      img {
        width: 60%;
        height: auto;
        margin: auto;
      }

      &--selected {
        background: color(blues, normal);

        &.non-turner {
          background: color(non-turner);
        }
      }
    }

    &__error {
      color: color(grays, extra-light);
    }

    &__actions {
      display: flex;
      align-items: center;
    }
  }
</style>



// WEBPACK FOOTER //
// ViewershipFilter.vue?5dfdd75e